/**
 * @preserve
 * Copyright 2015-2016 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
import { SSIM } from "./ssim"

export {
    SSIM
}



/** WEBPACK FOOTER **
 ** ./src/quality/index.ts
 **/